// src/pages/Reports/DistributorReport.jsx
import React from 'react';
import BusinessReport from './BusinessReport';

const DistributorReport = () => {
  return <BusinessReport userType="distributor" />;
};

export default DistributorReport;